import { Injectable } from '@angular/core'
import _ from 'lodash'
import { PubSub } from '../../../../core/services/pub-sub'
import { RoutePluginName, RoutePluginStepName } from '../models/plugin-configure-navigation.model'

const navigation = {
  [RoutePluginName.LiveVisitorCount]: [
    {
      url: RoutePluginStepName.Appearance,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Text,
      label: 'campaign_apps_page.common.text',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.BEHAVIOR,
      label: 'campaign_apps_page.common.triggers',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Image,
      label: 'campaign_apps_page.common.image',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Objectives,
      label: 'campaign_apps_page.common.objectives',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Advanced,
      label: 'campaign_apps_page.common.advanced',
      required: false,
      new: false,
    },
  ],
  [RoutePluginName.AggregateVisitorCount]: [
    {
      url: RoutePluginStepName.Appearance,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Text,
      label: 'campaign_apps_page.common.text',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.BEHAVIOR,
      label: 'campaign_apps_page.common.triggers',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Image,
      label: 'campaign_apps_page.common.image',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Objectives,
      label: 'campaign_apps_page.common.objectives',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Advanced,
      label: 'campaign_apps_page.common.advanced',
      required: false,
      new: false,
    },
  ],
  [RoutePluginName.AggregateActivity]: [
    {
      url: RoutePluginStepName.Collect,
      label: 'campaign_apps_page.common.collect',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Conversions,
      label: 'Conversions',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Products,
      label: 'campaign_apps_page.common.products',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Appearance,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Text,
      label: 'campaign_apps_page.common.text',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.BEHAVIOR,
      label: 'campaign_apps_page.common.triggers',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Image,
      label: 'campaign_apps_page.common.image',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Objectives,
      label: 'campaign_apps_page.common.objectives',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Advanced,
      label: 'campaign_apps_page.common.advanced',
      required: false,
      new: false,
    },
  ],
  [RoutePluginName.RecentActivity]: [
    {
      url: RoutePluginStepName.Collect,
      label: 'campaign_apps_page.common.collect',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Conversions,
      label: 'Conversions',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Orders,
      label: 'campaign_apps_page.common.orders',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Products,
      label: 'campaign_apps_page.common.products',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Appearance,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Text,
      label: 'campaign_apps_page.common.text',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.BEHAVIOR,
      label: 'campaign_apps_page.common.triggers',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Image,
      label: 'campaign_apps_page.common.image',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Objectives,
      label: 'campaign_apps_page.common.objectives',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Advanced,
      label: 'campaign_apps_page.common.advanced',
      required: false,
      new: false,
    },
  ],
  [RoutePluginName.FortuneWheel]: [
    {
      url: RoutePluginStepName.Theme,
      label: 'campaign_apps_page.common.theme',
      required: false,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Fields,
      label: 'campaign_apps_page.common.form',
      required: true,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Slices,
      label: 'campaign_apps_page.common.rewards',
      required: true,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Design,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Triggers,
      label: 'campaign_apps_page.common.triggers',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.MarketingEmails,
      label: 'campaign_apps_page.common.emails',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.MarketingSMS,
      label: 'campaign_apps_page.common.sms',
      required: true,
      new: false,
    },
  ],
  [RoutePluginName.CouponBox]: [
    {
      url: RoutePluginStepName.Theme,
      label: 'campaign_apps_page.common.theme',
      required: false,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Fields,
      label: 'campaign_apps_page.common.form',
      required: true,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Design,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Coupon,
      label: 'campaign_apps_page.common.reward',
      required: true,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Triggers,
      label: 'campaign_apps_page.common.triggers',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.MarketingEmails,
      label: 'campaign_apps_page.common.emails',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.MarketingSMS,
      label: 'campaign_apps_page.common.sms',
      required: true,
      new: false,
    },
  ],
  [RoutePluginName.NewsLetterNotification]: [
    {
      url: RoutePluginStepName.Theme,
      label: 'campaign_apps_page.common.theme',
      required: false,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Fields,
      label: 'campaign_apps_page.common.form',
      required: true,
      new: false,
      quickStep: true,
    },
    {
      url: RoutePluginStepName.Design,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Triggers,
      label: 'campaign_apps_page.common.triggers',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.MarketingEmails,
      label: 'campaign_apps_page.common.emails',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.MarketingSMS,
      label: 'campaign_apps_page.common.sms',
      required: true,
      new: false,
    },
  ],
  [RoutePluginName.FreeShipping]: [
    {
      url: RoutePluginStepName.Theme,
      label: 'campaign_apps_page.common.theme',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Design,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Coupon,
      label: 'campaign_apps_page.common.reward',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.Triggers,
      label: 'campaign_apps_page.common.triggers',
      required: true,
      new: false,
    },
  ],
  [RoutePluginName.SalesPopup]: [
    {
      url: RoutePluginStepName.Theme,
      label: 'campaign_apps_page.common.theme',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Design,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Coupon,
      label: 'campaign_apps_page.common.reward',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.Triggers,
      label: 'campaign_apps_page.common.triggers',
      required: true,
      new: false,
    },
  ],
  [RoutePluginName.ProductPopup]: [
    {
      url: RoutePluginStepName.Theme,
      label: 'campaign_apps_page.common.theme',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Products,
      label: 'campaign_apps_page.common.products',
      required: true,
      new: false,
    },
    {
      url: RoutePluginStepName.Design,
      label: 'campaign_apps_page.common.design',
      required: false,
      new: false,
    },
    {
      url: RoutePluginStepName.Triggers,
      label: 'campaign_apps_page.common.triggers',
      required: true,
      new: false,
    },
  ],
}

@Injectable()
export class PluginConfigureNavigationService extends PubSub<any> {
  public defaultNavigation = _.cloneDeep(navigation)
  constructor() {
    super(navigation)
  }
}
